import identity from 'lodash/identity';
/** Makes sure an array contains only truthy values */
export const unaryEvery = (arr) => arr.every(identity);
/** Make sure arguments (as in selectors) are all boolean values  */
export const selectUnaryEvery = (...args) => unaryEvery(args);
//# sourceMappingURL=unaryEvery.js.map